const getFileUploadResult = (result)=>{
    var ref;
    if (typeof result === 'string') {
        return result;
    }
    if (!result) {
        return null;
    }
    const errorKey = 'errors' in result ? (ref = result.errors[0]) === null || ref === void 0 ? void 0 : ref.code : result.message;
    const key = (errorKey !== null && errorKey !== void 0 ? errorKey : '').toLowerCase();
    const keyToLabelMap = {
        'file-invalid-type': 'file not supported',
        'file-too-large': 'file too large',
        'too-many-files': 'too many files'
    };
    if (key.includes('recaptcha')) {
        return 'upload not possible - recaptcha';
    }
    return keyToLabelMap[key] || null;
};

export { getFileUploadResult };
//# sourceMappingURL=get-file-upload-result.js.map
